import React from "react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";
import { dashboardStyles } from "./dashboard-styles";

type KpiGridProps = {
  children: React.ReactNode;
  loading?: boolean;
  skeletonCount?: number;
  columns?: string;
  className?: string;
};

export function KpiGrid({
  children,
  loading = false,
  skeletonCount = 4,
  columns = "grid-cols-1 sm:grid-cols-2 xl:grid-cols-4",
  className,
}: KpiGridProps) {
  return (
    <Card className={cn(dashboardStyles.kpiGridWrapper, className)}>
      <div className={cn("grid w-full gap-3", columns)}>
        {loading
          ? Array.from({ length: skeletonCount }).map((_, i) => (
              <Card
                key={i}
                className="min-h-[148px] rounded-[1.25rem] border border-[#EBEBEB] bg-white p-5 shadow-none"
              >
                <div className="flex h-[148px] flex-col">
                  <Skeleton className="h-5 w-5 rounded" />
                  <Skeleton className="mt-4 h-8 w-20" />
                  <Skeleton className="mt-auto h-4 w-16" />
                </div>
              </Card>
            ))
          : children}
      </div>
    </Card>
  );
}
